import { useT } from "../../i18n";

export const Deliverables = () => {
  const t = useT();
  return (
    <section
      id="program"
      className="sp-section sp-section--alt"
      data-testid="section-program"
    >
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.deliverables.eyebrow}</span>
          <h2 className="sp-title">
            {t.deliverables.titlePre}
            <em>{t.deliverables.titleEm}</em>
          </h2>
          <p className="sp-lead">{t.deliverables.lead}</p>
        </div>
        <div className="sp-del-grid sp-reveal">
          {t.deliverables.items.map((it) => (
            <div className="sp-del-item" key={it.n}>
              <span className="sp-del-num">{it.n}</span>
              <h3>{it.title}</h3>
              <p>{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
